export default function allowed_included_services(membership_type){
    return [
        "funnels",
        "suite",
        "suite_only_websites"
    ].includes(membership_type)
}
